import styled from 'styled-components';
import { CloseIcon } from 'src/modules/login/components/mfa-modal/styles';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  background: #f3f4f8;
  border-radius: 20px;
`;

export const CommonInputDiv = styled.div`
  width: 300px;
  select {
    width: 100%;
  }
`;

export const InputContainer = styled.div`
  padding: 30px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 30px;
  opacity: 1;
  width: 100%;

  border-radius: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 7px;
  font: Biotif, Medium;
  color: #1c1b3a;
  opacity: 1;

  margin-top: 14px;
  margin-left: 8px;
  font-size: 26px;
  font-weight: 600;
  ${CloseIcon} {
    cursor: pointer;
  }
`;

export const FormRow = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
`;

export const FormRowLast = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

export const ResetPasswordWrapper = styled.div`
  width: fit-content;
  margin: 0 auto;
`;

export const InputLabel = styled.label`
  display: block;
  margin-bottom: 11px;
`;

export const LoginInput = styled.div`
  display: flex;
  height: 30px;
  align-items: center;
  align-self: center;
  width: 400px;
`;

export const ModalInput = styled(LoginInput)`
  position: relative;
  display: flex;
  align-items: center;
  height: 44px;
  width: 400px;
`;

export const InputIcon = styled.img`
  height: auto;
  width: 24px;
`;

export const EmailIcon = styled(InputIcon)`
  position: absolute;
  width: 18px;
  left: 16px;
`;

export const Input = styled.input`
  max-width: 100%;
  height: 100%;
  width: 100%;
  padding: 0 80px 0 42px;
  font-weight: bold;
  border: 1px solid #c9cbd3;
  border-radius: 4px;
  &::placeholder {
    color: #9399b2;
    font-weight: 400;
  }
`;

export const StyledErrorWrap = styled.p`
  margin: 0;
  font-size: 14px;
  color: red;
`;

export const CompanyGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(5, 1fr);
  gap: 10px 30px;
`;

export const CheckBoxContainer = styled.div`
  display: flex;
`;
